define('plugin/line-liff/view/LineLiffFriendshipDialogView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    return LayoutView.extend({

        template: '#line_liff_friendship_dialog_view',
        ui: {
            confirmBtn: '#sb_line_liff_friendship_confirm',
            backBtn: '#sb_line_liff_friendship_cancel'
        },
        triggers: {
            'click @ui.confirmBtn': {
                'event': 'confirm',
                'preventDefault': false,
                'stopPropagation': false
            },
            'click @ui.backBtn': {
                'event': 'cancel',
                'preventDefault': false,
                'stopPropagation': false
            }
        }

    });

});
